import React from "react";

export default function Manajemen1(){
    return(
        <div className="flex flex-col w-full px-10 items-center justify-center pb-10">
            <div className="text-4xl font-medium text-center">
            Manajemen Pengguna
            </div>
            <div className="text-sm text-center">
            Kelola seluruh pengguna aplikasi Dapur Merdeka dengan mudah, atur peran, akses, dan status akun.
            </div>
        </div>

    )
}